import Mediator from "../../utilities/Mediator";

var MediatorTrigger = {
  instance: function () {
    if (!MediatorTrigger.instance) {
      MediatorTrigger.instance = this;
    }
    return MediatorTrigger.instance;
  },

  triggerConfigSelected: null,
  mainTriggerVue: null,
  triggersConfigVue: null,
  triggersVue: new Map(),

  async notify(sender, event) {

    switch (event) {
      case "init-config-trigger":
        this.triggersConfigVue = sender;
        break

      case "init-triggers":
        this.mainTriggerVue = sender
        if(this.triggerConfigSelected){
          this.mainTriggerVue.selectTriggerConfig(this.triggerConfigSelected)
        }
        break

      case "init-trigger-field":
        this.triggersVue.set(sender.trigger, sender)
        break

      case "select-trigger-config":
        selectTriggerConfig(sender)
        break

      case "remove-trigger-config":
        removeTriggerConfig(sender)
        break
        
      case "selected-trigger":
        selectTrigger(sender)
        break

      case "active-trigger":
        let trigger = this.triggersConfigVue.triggers.find(t => t.triggercode == this.triggersConfigVue.triggerSelected)
        if(!trigger) return
        trigger.active = sender
        updateIndicator();
        break
    }
  }
}

function updateIndicator(){
  Mediator.notify(null, 'save-trigger')
}

function selectTrigger(sender) {
  let target = sender.target;
  if(!target.id) return
  
  MediatorTrigger.triggersConfigVue.triggerSelected = target.id
  let triggers = document.querySelectorAll(".trigger-tab")
  triggers.forEach(t => t.classList.remove("selected"))
  target.classList.add("selected")
}

function selectTriggerConfig(sender){
  MediatorTrigger.triggersConfigVue.lockAll = false;
  MediatorTrigger.triggersConfigVue.triggerConfigName = sender
  MediatorTrigger.triggersConfigVue.triggers = Mediator.triggers.getTriggersSelected(sender)
  MediatorTrigger.triggerConfigSelected = sender
  let triggercode = MediatorTrigger.triggersConfigVue.triggerSelected

  setTimeout(() => {
    let el = document.getElementById(triggercode)
    if(el)
      el.click()
  }, 100);
}

function removeTriggerConfig(sender){
  Mediator.notify(sender, "remove-trigger-config")
  if(sender == MediatorTrigger.triggerConfigSelected){
    MediatorTrigger.triggersConfigVue.lockAll = true;
    MediatorTrigger.triggerConfigSelected = null;
  }
}

export default MediatorTrigger